import { isPageExist } from '../header/header';
import {
  mobileHandleSearch,
  openSearchHandler,
  removeSearchContainer, searchResizeCanvas,
} from '../search/search';
import {
  changeLangToCurrent,
  getCurrentLangDirection,
  isDesktopMode,
} from '../language/langSwitcher';
import { isMobile, projectMode, settingsData, threeJsVariables } from '../../settings';
import {
  autoRotateTimerAction,
  getOrbitControlsCurrentPolarAngle, hideOrbitToMapButton,
  isOrbitControlsEnabled,
} from '../controls/orbitControls';
import { CardTypes, ViewMode } from '../../common';
import gsap from 'gsap';
import {createHtmlElement, get_url_param, getUrlParam, removePropParam, userPrevent} from '../../functions';
import { clickAudio, hoverAudio, menuAudio, muteToggle } from '../audio/audio';
import { canvasResize, updateRenderer } from '../../app';
import { openContactUs, removeContactUs } from '../contactUs/contactUs';
import { openGetApp, removeGetApp } from '../getApp/getApp';
import { buttonsWrapperHandler, toggleBackBtnInDesktopMode, viewModesSwitching } from '../navigation/right-nav-bar';
import { moveFormToBlock } from '../form/form';
import { checkMapPanoramaInOrbit } from '../poi/poi';
import {runCameraTour, showHideButtonPlay, stopCameraTour} from "../camera-auto-tour/cameraTour";
import {UnitCardClass} from "../cards/unitCards/UnitCardClass";
import {closeOptionsCard} from "../cards/cardsFunctions";
import { enterToTheBuildingWithMaxAvailableApartments } from '../building-switch/building_switch';
import { setActiveLordIcon, setLordIcon } from '../../lordicon';
import { mapElementStyleToggle } from '../widgets/poi/poiv3';
import { analytics } from '../analytics/analytics';
import {createModal} from "../cards/urlParamModal";
import {openOptionsCard} from "../cards/optionsCards";
import {PrivacyAndTerms} from "./PrivacyAndTerms";
import {closeContactWidget} from "../chats/chats";
;
let clickTourTimer = null;

export function menuInit (crmSettings) {
  const param = settingsData.isDesktopMode;

  const aside = createHtmlElement(document.body, '', 'aside', ['aside__container']);
  const substrate = createHtmlElement(document.body, '', 'div', ['aside__open-menu__substrate']);
  const topContainer = createHtmlElement(aside, '', 'div', ['aside__top__container']);
  const bottomContainer = createHtmlElement(aside, '', 'div', ['aside__bottom__container']);
  const burger = createHtmlElement(topContainer, '', 'div', ['aside__burger__btn', 'icon-burger3']);
  // burger.onclick = () => menuAudio();
  // burger.onmouseenter = () => hoverAudio();

  new PrivacyAndTerms({parent: bottomContainer});

  let asideOpened = false;


 /* if (getUrlParam('deviceid')) {
    const text = `deviceid >> ${getUrlParam('deviceid')}, type >> ${getUrlParam('type')}`;
    const textEl = createHtmlElement(aside, '', 'div').innerHTML = text;
  }*/

  if (param && !isMobile) {
    aside.classList.add('important-right-side');
    const logo = createHtmlElement(aside, '', 'div', ['aside__logo']);
    logo.addEventListener('click',logoHandler);
    const img = createHtmlElement(logo, '', 'img', ['logo__img']);
    img.src = crmSettings.general.logo;
    document.body.classList.add('desktop-mode');
  } else {

    if (crmSettings.general.fullWebsite && !isMobile) {
      burger.style.display = 'none';
      const logo = createHtmlElement(topContainer, '', 'div', ['aside__logo']);
      logo.addEventListener('click',logoHandler);
      const img = createHtmlElement(logo, '', 'img', ['logo__img']);
      img.src = crmSettings.general.logo;
      aside.classList.add('important-open-aside-menu');

      // resizeCanvasWhenMenuOpened();
      canvasResize();
      asideOpened = true;
    }

  }

// For mobile portrait mode
  let burgerCopy;

  if (isMobile) {
    const logo = createHtmlElement(topContainer, '', 'div', ['aside__logo']);
    // logo.addEventListener('click',logoHandler);
    const img = createHtmlElement(logo, '', 'img', ['logo__img']);
    img.src = crmSettings.general.logo;
    burgerCopy = createHtmlElement(document.body, '', 'div', ['burger__mobile__btn', 'icon-burger3']);
    aside.classList.add('active-aside-menu');
    burgerCopy.addEventListener('click', () => {
      // asideHandler(aside);
      aside.classList.toggle('mobile-menu__show');
    });
    burgerCopy.onclick = () => menuAudio();
    burgerCopy.onmouseenter = () => hoverAudio();
  }

  let languageSwitcherContainerParent = topContainer;
  isDesktopMode() && (languageSwitcherContainerParent = bottomContainer);

  let languageSwitcherContainer = null;
  if (!isDesktopMode())
    languageSwitcherContainer = createHtmlElement(
        languageSwitcherContainerParent,
        '',
        'div',
        ['aside__language-switcher']
    );

  const nav = createHtmlElement(topContainer, '', 'nav', ['aside__navigation__menu']);
  const navList = createHtmlElement(nav, '', 'ul', ['aside__navigation_list']);

  const model3D = createHtmlElement(navList, '', 'li', ['aside__navigation-menu__item', 'aside__model__container', 'aside__active-menu']);
  model3D.dataset.menuItem = '3dModel';
  model3D.onmouseenter = () => hoverAudio();
  model3D.onclick = () => clickAudio();

  setLordIcon('3dModel',model3D,{
    trigger:'hover',
    delay:'0'
  },undefined,true);

// const span3D = createHtmlElement(model3D,'','span',['aside__navigation-menu__href__wrapper']);
// const menuHref3D = createHtmlElement(span3D,'','a',['aside__navigation-menu__href']);
  const text3D = createHtmlElement(model3D, changeLangToCurrent(model3D.dataset.menuItem), 'span', ['aside__navigation-menu__text', 'language-string']);
  text3D.dataset.menuItem = model3D.dataset.menuItem;
  text3D.setAttribute('data-dictionary', model3D.dataset.menuItem);

// if (isDesktopMode()){
//
//   const backContainer = createHtmlElement(navList,'','li',['aside__navigation-menu__item','aside__back__container','icon-right','hide']);
//   backContainer.dataset.menuItem = 'Back';
//   backContainer.dataset.button = 'back';
//   backContainer.onmouseenter = () => hoverAudio();
//   backContainer.onclick = () => {
//     clickAudio();
//     buttonsWrapperHandler(backContainer);
//   };
//
//   const backText = createHtmlElement(backContainer,changeLangToCurrent(backContainer.dataset.menuItem),'span',['aside__navigation-menu__text','aside__navigation-menu__text','language-string']);
//   backText.dataset.menuItem = backContainer.dataset.menuItem;
//   backText.dataset.button = backContainer.dataset.button;
//   backText.setAttribute('data-dictionary', backContainer.dataset.menuItem);
//
// }
  if (!isDesktopMode() && !config.features?.blockCylinderMode) {
    // const searchContainer = createHtmlElement(navList, '', 'li', ['aside__navigation-menu__item', 'aside__search__container', 'icon-search']);
    const searchContainer = createHtmlElement(navList, '', 'li', ['aside__navigation-menu__item', 'aside__search__container']);
    setLordIcon('search',searchContainer);
    searchContainer.dataset.menuItem = 'search';
    searchContainer.onmouseenter = () => hoverAudio();
    searchContainer.onclick = () => clickAudio();

    const searchText = createHtmlElement(searchContainer, changeLangToCurrent(searchContainer.dataset.menuItem), 'span', ['aside__navigation-menu__text', 'aside__navigation-menu__text', 'language-string']);
    searchText.dataset.menuItem = searchContainer.dataset.menuItem;
    searchText.setAttribute('data-dictionary', searchContainer.dataset.menuItem);
  } else {
    const backBtn = createHtmlElement(topContainer,'','button',['menu__back-btn','button-modes','button-modes--back','icon-back','prevent-hide']);
    backBtn.dataset.button = 'back';
    backBtn.addEventListener('click',buttonsWrapperHandler);
  }
// const searchContainer = createHtmlElement(navList,'','li',['aside__navigation-menu__item','aside__search__container','icon-search']);
// searchContainer.dataset.menuItem = 'search';
// searchContainer.onmouseenter = () => hoverAudio();
// searchContainer.onclick = () => clickAudio();
//
// const searchText = createHtmlElement(searchContainer,changeLangToCurrent(searchContainer.dataset.menuItem),'span',['aside__navigation-menu__text','aside__navigation-menu__text','language-string']);
// searchText.dataset.menuItem = searchContainer.dataset.menuItem;
// searchText.setAttribute('data-dictionary', searchContainer.dataset.menuItem);
  const isApplication = get_url_param('minimap');
  Object.entries(crmSettings.general.menuItems).forEach(([key, value], index) => {
    if (value && key !== '3dModel') {

      if (key === 'getApp' && isApplication ){
        return;
      }

      const webName = changeLangToCurrent(key);
      const menuItem = createHtmlElement(navList, '', 'li', ['aside__navigation-menu__item']);
      const span = createHtmlElement(menuItem, '', 'span', ['aside__navigation-menu__href__wrapper']);
      const menuHref = createHtmlElement(span, '', 'a', ['aside__navigation-menu__href']);
      const text = createHtmlElement(menuHref, webName, 'span', ['aside__navigation-menu__text', 'language-string']);
      text.setAttribute('data-dictionary', key);
      menuHref.dataset.menuItem = key;
      menuItem.dataset.menuItem = key;
      menuItem.onmouseenter = () => hoverAudio();
      menuItem.onclick = () => clickAudio();

      text.dataset.menuItem = key;

      // if (key === 'about' || key === 'gallery' || key === 'map'){
      //   setTimeout(()=>{
      //     openPage(key,crmSettings.general,true);
      //   },400)
      // }

      // if (key === '3dModel'){
      //   menuItem.classList.add('aside__active-menu');
      // }

    }
  });

  if (!config.features?.blockCylinderMode) {
    insertSearchBtnToTheCenterOfMenu();
  }
  addAdditionalMenu(crmSettings.general);

  if (config.languages.length > 1) {

    let langToggleContainer = languageSwitcherContainer;
    if (isDesktopMode()) langToggleContainer = bottomContainer;

    // const langToggle = createHtmlElement(bottomContainer, '', 'div', ['header__lang-toggle']);
    const langToggle = createHtmlElement(langToggleContainer, '', 'div', ['header__lang-toggle']);
    setLordIcon('lang',langToggle,{
      trigger: 'hover',
      delay:'0'
    });
    // langToggle.onmouseenter = () => hoverAudio();
    // langToggle.onclick = () => clickAudio();
  }



  // const soundBtn = createHtmlElement(bottomContainer, '', 'div', ['aside__sound__btn', 'aside__bottom__btn']);
  // setLordIcon('soundOn',soundBtn,{
  //   trigger: 'morph',
  //   delay:'0'
  // });
  // setLordIcon('soundOff',soundBtn,{
  //   trigger: 'morph',
  //   delay:'0'
  // });

  // soundBtn.dataset.active = 'off';
  // soundBtn.onmouseenter = () => hoverAudio();
  // soundBtn.onclick = () => clickAudio();
  // const shareBtn = createHtmlElement(bottomContainer, '', 'div', ['aside__share__btn', 'aside__bottom__btn', 'icon-share']);
  // shareBtn.onmouseenter = () => hoverAudio();
  // shareBtn.onclick = () => clickAudio();

  // if (config.features.projectTour.active && !projectMode.LiteMode.isActive()) {
  //   const playBtn = createHtmlElement(bottomContainer, '', 'div', ['aside__play__btn', 'aside__bottom__btn','icon-play']);
  //   setLordIcon('play',playBtn,{
  //     trigger: 'hover',
  //     delay:'0'
  //   });
  //
  //   // playBtn.onmouseenter = () => hoverAudio();
  //   playBtn.onclick = () => {
  //     // clickAudio();
  //     if (clickTourTimer !== null) {
  //       clearTimeout(clickTourTimer);
  //     }
  //
  //     clickTourTimer = setTimeout(() => playBtnHandler(playBtn), 300);
  //   };
  // }

  setMenuIcoMoon();
  setMenuPositionDataAttribute();

  aside.dataset.initialWidth = isDesktopMode() ? 0 : Math.round(aside.getBoundingClientRect().width);

  setTimeout(()=>{
    resizeMenu();
  },200);
  animateMenu(aside, burgerCopy, asideOpened);

  burger.addEventListener('click', () => asideHandler(aside));
  substrate.addEventListener('click', () => asideHandler(aside));
  navList.addEventListener('click', (e) => menuHandler(e, crmSettings.general));
  // soundBtn.addEventListener('click', muteToggle);


}



function playBtnHandler(btn) {
  if (settingsData.activeViewMode !== ViewMode.Orbit) return;
  if (userPrevent()) return;

  settingsData.tourIsActive ? stopCameraTour(btn) : runCameraTour();
  btn.classList.toggle('icon-play');
  btn.classList.toggle('icon-pause');
  isMobile && closeAsideMenu();
}

function logoHandler () {
  removePropParam();
  projectMode.Pagination.paginate({source: 'logoHandler'});
  window.location.reload();
}

function addAdditionalMenu (crm) {
  if (!isMobile) {
    return;
  }

  const container = createHtmlElement(document.body, '', 'div', ['additional-menu__container']);
  const wrapper = createHtmlElement(container, '', 'div', ['additional-menu__wrapper']);
  const shape = createHtmlElement(wrapper, '', 'div', ['additional-menu__shape']);
  const nav = createHtmlElement(shape, '', 'ul', ['additional-menu__navigation']);

  let contact;


  if (settingsData.isConferenceHost) {
    contact = config.features.contactWidget.active ? 'contactWidget' : 'contactUs';
  } else {
    contact = config.contactWidget.active ? 'contactWidget' : 'contactUs';
  }

  [contact, 'map', 'gallery', '3dModel'].forEach((btn, index) => {

    let li = createHtmlElement(nav, '', 'li', ['additional-menu__item']);

    setLordIcon(btn,li,{
      trigger: 'hover',
      delay:'0'
    });

    li.dataset.menuItem = btn;
    li.onmouseenter = () => hoverAudio();
    li.onclick = () => clickAudio();

    if (btn === '3dModel') {
      li.classList.add('additional-menu__active');
    }

    if(index == 1 && !config.features?.blockCylinderMode){
      const search = createHtmlElement(nav, '', 'li', ['additional-menu__item','additional-menu__search', 'icon-search']);
      search.dataset.menuItem = 'search';
      setLordIcon('search',search);
      search.onmouseenter = () => hoverAudio();
      search.onclick = () => clickAudio();
    }

  });

  const fragment = document.createDocumentFragment();

  nav.insertBefore(fragment, nav.childNodes[1]);

  nav.addEventListener('click', (e) => menuHandler(e, crm.general));

}

function insertSearchBtnToTheCenterOfMenu () {
  if (isDesktopMode()) {
    const nav = document.querySelector('.aside__navigation_list');
    const totalElements = nav.childElementCount;
    const searchElementIndex = Math.floor(totalElements / 2);
    const fragment = document.createDocumentFragment();

    const searchContainer = createHtmlElement(fragment, '', 'li', ['aside__navigation-menu__item', 'aside__search__container', 'icon-search']);

    searchContainer.dataset.menuItem = 'search';

    setLordIcon('search',searchContainer);
    searchContainer.onmouseenter = () => hoverAudio();
    searchContainer.onclick = () => clickAudio();

    const searchText = createHtmlElement(searchContainer, changeLangToCurrent(searchContainer.dataset.menuItem), 'span', ['aside__navigation-menu__text', 'aside__navigation-menu__text', 'language-string']);
    searchText.dataset.menuItem = searchContainer.dataset.menuItem;
    searchText.setAttribute('data-dictionary', searchContainer.dataset.menuItem);

    nav.insertBefore(fragment, nav.childNodes[searchElementIndex]);

  }
}

export function importantHtmlDirection (direction) {
  const html = document.querySelector('html');
  html.dataset.importantDirection = direction;
}

export function setMenuPositionDataAttribute () {
  const menu = document.querySelector('.aside__container');
  const currentDirection = getCurrentLangDirection();
  const importantDirection = isDesktopMode();

  if (importantDirection) {
    menu.dataset.menuPosition = 'right';
  } else {
    switch (currentDirection) {
      case 'rtl':
        menu.dataset.menuPosition = 'right';
        break;
      case 'ltr':
        menu.dataset.menuPosition = 'left';
        break;
    }
  }
}

export function resizeCanvasWhenMenuOpened () {
  const menu = document.querySelector('.aside__container.important-open-aside-menu');
  if (menu) {
    // const langDirection = getCurrentLangDirection();
    const menuWidth = menu.getBoundingClientRect().width;
    let finallyWidth;

    // switch (langDirection) {
    //   case 'rtl':
    //       finallyWidth = window.innerWidth + menuWidth;
    //     break;
    //   case 'ltr':
    //     finallyWidth = window.innerWidth - menuWidth;
    //     break;
    //
    // }
    finallyWidth = window.innerWidth + menuWidth;

    const size = {
      innerWidth: finallyWidth,
      innerHeight: window.innerHeight,
    };

    canvasResize(size);
  }
}

export function changeMenuStyle () {
  if (!isMobile) {
    return;
  }
  const burgerMenu = document.querySelector('.aside__burger__btn');

  if (!burgerMenu) {
    return;
  }

  switch (settingsData.activeViewMode) {
    case ViewMode.Orbit:
      const angle = getOrbitControlsCurrentPolarAngle();
      if (angle < 1) {
        burgerMenu.classList.add('menu__substrate');
      } else {
        burgerMenu.classList.remove('menu__substrate');
      }
      break;
    case ViewMode.Cylinder:
      burgerMenu.classList.add('menu__substrate');
      break;
  }
}

export function getActiveMenuData () {
  return document.querySelector('li.aside__active-menu').dataset.menuItem;
}

export async function menuHandler (e, crm) {
  closeContactWidget();
  // const gotoMapButton = document.getElementsByClassName('orbit-to-map-button')[0];
  // gotoMapButton && gotoMapButton.classList.add('hidden');
  if (!userPrevent()) projectMode.Pagination.paginate({source: 'menuHandler', menuItem: e.target.dataset.menuItem});
  projectMode.Pagination.prevent = true;
  // console.log('userPrevent:', userPrevent());
  if (document.querySelector(`.${CardTypes.Options}-card`)) {
    if (document.querySelector('.form__container-main')) moveFormToBlock();
      closeOptionsCard();
  }
  if (document.querySelector(`.apply__main-container:not(.chats)`)) document.querySelector(`.apply__main-container:not(.chats)`).remove();

  if (!threeJsVariables.orbitControls.enabled && !settingsData.tourIsActive && !projectMode.LiteMode.isActive()){
    return;
  }

  if (config.features?.projectTour?.active) {
    settingsData.tourIsActive && stopCameraTour();

    // e.target.dataset.menuItem !== '3dModel'
    //     ? showHideButtonPlay('hide')
    //     : showHideButtonPlay('show');
  }

  let orbitPanorama;
  const streetView = document.querySelector('.map__panorama')

  switch (e.target.dataset.menuItem) {
    case 'search':
      if (userPrevent() || settingsData.loadingError) return;

      hideOrbitToMapButton();

      orbitPanorama = checkMapPanoramaInOrbit();
      orbitPanorama && orbitPanorama.classList.remove('map__panorama__orbit__show');
      streetView && streetView.classList.remove('map__panorama__show');

      const unitCard = UnitCardClass.findCard()?.html;

      settingsData.stopRender = false;
      const searchContainer = document.querySelector('.search__container-main');

      removeContactUs();
      removeGetApp();
      closePages();

      if (searchContainer) {

        if (isMobile) {
          const isMinimized = searchContainer.classList.contains('minimize');
          const action = (isMinimized) ? 'swiped-up' : 'swiped-down';
          if (settingsData.isLandscape && unitCard) {
            unitCard.style.opacity = 0;
          }
          const delay = settingsData.isLandscape && unitCard ? 0.8 : 0;

          mobileHandleSearch({type: action, delay});
        }

        setMenuActive(e.target.dataset.menuItem);
        // settingsData.userPrevent = false;

      } else {

        if (unitCard && isMobile) UnitCardClass.closeMobileCard();

        if (settingsData.activeViewMode === ViewMode.Orbit){
          enterToTheBuildingWithMaxAvailableApartments();
        } else {
          openSearchHandler();
        }
      }

      analytics('page_entrance','search');
      closeAsideMenu();
      break;
    case '3dModel':
      if (userPrevent()) return;
      if (settingsData.activeViewMode === ViewMode.Orbit) showHideButtonPlay('show');

      // userPrevent(true);
      // showHideButtonPlay('show');
      orbitPanorama = checkMapPanoramaInOrbit();
      orbitPanorama && orbitPanorama.classList.remove('map__panorama__orbit__show');
      streetView && streetView.classList.remove('map__panorama__show');

      settingsData.stopRender = false;
      // updateRenderer();
      removeContactUs();
      removeGetApp();
      // removeSearchContainer();
      // setMenuActive(e.target.dataset.menuItem);
      closePages();
      closeAsideMenu();
      if (settingsData.activeViewMode !== ViewMode.Orbit) {
        await viewModesSwitching(ViewMode.Orbit);
      } else {
        toggleBackBtnInDesktopMode('hide');
        setMenuActive(e.target.dataset.menuItem);
      }
      analytics('page_entrance','3dModel');

      break;
    case 'contactUs':
      if (userPrevent()) return;

      if (settingsData.activeViewMode === ViewMode.Orbit) showHideButtonPlay('show');

      removeGetApp();
      orbitPanorama = checkMapPanoramaInOrbit();
      orbitPanorama && orbitPanorama.classList.remove('map__panorama__orbit__show');

      settingsData.stopRender = false;
      const contactUs = document.querySelector('.contact-us');
      if (contactUs) {
        if (document.querySelector('.form__container-main')) moveFormToBlock();
        removeContactUs();
        isMobile && mobileBurgerStyleToggle();
      } else {
        if (isMobile) {
          mobileHandleSearch({type: 'swiped-down'});
        } else {
          removeSearchContainer();
        }
        openContactUs();
        closePages();
        setMenuActive(e.target.dataset.menuItem);
      }
      closeAsideMenu();
      analytics('page_entrance','contactUs');
      break;
    case 'getApp':
      if (userPrevent()){
        return;
      }

      if (settingsData.activeViewMode === ViewMode.Orbit){
        showHideButtonPlay('show');
      }
      removeContactUs();
      orbitPanorama = checkMapPanoramaInOrbit();
      orbitPanorama && orbitPanorama.classList.remove('map__panorama__orbit__show');

      settingsData.stopRender = false;
      const getApp = document.querySelector('.get-app');
      if (getApp) {
        if (document.querySelector('.form__container-main')) moveFormToBlock();
        removeGetApp();
        isMobile && mobileBurgerStyleToggle();
      } else {
        if (isMobile) {
          mobileHandleSearch({type: 'swiped-down'});
        } else {
          removeSearchContainer();
        }
        openGetApp();
        closePages();
        setMenuActive(e.target.dataset.menuItem);
      }
      closeAsideMenu();
      analytics('page_entrance','getApp');
      break;
    default:
      if (e.target.dataset.menuItem) {

        if (userPrevent()) return;

        if (e.target.dataset.menuItem === 'map' && settingsData.buildingDestroyed) {
          closeAsideMenu();
          await projectMode.FloorPlan.exitFromMode();
          if (settingsData.activeViewMode !== ViewMode.Orbit)
            await viewModesSwitching(ViewMode.Orbit);
        }

        showHideButtonPlay('hide');
        toggleBackBtnInDesktopMode('show');
        if (isMobile) {
          mobileHandleSearch({type: 'swiped-down'});
        } else {
          // removeSearchContainer();
        }
        removeContactUs();
        removeGetApp();
        const page = getActivePage();
        if (page && page.dataset.menuItem !== e.target.dataset.menuItem){
          openPage(e.target.dataset.menuItem, crm);
          setTimeout(()=>{
            closePages(page);
          },100)
        } else {
          openPage(e.target.dataset.menuItem, crm);
        }
        setMenuActive(e.target.dataset.menuItem);
        // openPage(e.target.dataset.menuItem, crm);
        // closePages(page);
        closeAsideMenu();
        settingsData.stopRender = true;
        setTimeout(()=>{
          orbitPanorama = checkMapPanoramaInOrbit();
          orbitPanorama && orbitPanorama.classList.remove('map__panorama__orbit__show');
          streetView && streetView.classList.remove('map__panorama__show');
        },100);

        analytics('page_entrance',e.target.dataset.menuItem);
      }
      break;
  }


  autoRotateTimerAction('update');

  const compareBlock = document.querySelector(`.compare-block`);

  if (compareBlock) compareBlock.remove();

  projectMode.Pagination.prevent = false;
}

export function closePages (page) {
  const activePage = page || document.querySelector('.widget__container.show-page');
  activePage && activePage.classList.remove('show-page');
  mobileBurgerStyleToggle();
  mapElementStyleToggle(activePage);
}

function getActivePage () {
  return document.querySelector('.widget__container.show-page');
}

function asideHandler (aside) {
  if (settingsData.tourIsActive) {
    stopCameraTour();
  }
  !isMobile && aside.classList.toggle('active-aside-menu');
  aside.classList.contains('mobile-menu__show') && aside.classList.remove('mobile-menu__show');
  // removeSearchContainer();
  // if (isMobile) {
  //   mobileHandleSearch({type: 'swiped-down'});
  // } else {
  //   removeSearchContainer();
  // }
}

export function setMenuActive (data) {
  const activeMenu = document.querySelector('li.aside__active-menu');
  const selectedMenu = document.querySelector('li[data-menu-item="' + data + '"]');
  activeMenu.classList.remove('aside__active-menu');
  selectedMenu.classList.add('aside__active-menu');

  setActiveLordIcon(data, document.querySelector('.aside__navigation_list'));

  if (isMobile) {
    const activeAdditionalMenu = document.querySelector('li.additional-menu__item.additional-menu__active');
    const selectedAdditionalMenu = document.querySelector('li.additional-menu__item[data-menu-item="' + data + '"]');
    activeAdditionalMenu && activeAdditionalMenu.classList.remove('additional-menu__active');
    selectedAdditionalMenu && selectedAdditionalMenu.classList.add('additional-menu__active');
  }
}

export function closeAsideMenu () {
  const menu = document.querySelector('.aside__container');
  if (isMobile) {
    menu.classList.contains('mobile-menu__show') && menu.classList.remove('mobile-menu__show');
  } else {
    menu.classList.remove('active-aside-menu');
  }
  // if (menu.classList.contains('active-aside-menu')){
  //   menu.classList.remove('active-aside-menu');
  //
  // }
}

export function resizeMenu () {
  return;
  if (!isMobile){
    return;
  }
  const menu = document.querySelector('.aside__container');
  if (menu) {
    const navList = document.querySelector('.aside__navigation_list');
    const menuHeight = menu.offsetHeight;
    const scrollHeight = menu.scrollHeight;

    if (scrollHeight <= menuHeight) {
      navList.style.maxHeight = '';
      return;
    }

      const navListHeight = navList.getBoundingClientRect().height;
      const navListMaxHeight = navListHeight - (scrollHeight - menuHeight);
      navList.style.maxHeight = navListMaxHeight + 'px';
  }
}

export function openPage (data, crm, autoLoad = false) {
  const menu = document.querySelector('.aside__container');
  const direction = getCurrentLangDirection();
  const marginLang = direction === 'ltr' ? 'marginLeft' : 'marginRight';
  const paddingLang = direction === 'ltr' ? 'paddingLeft' : 'paddingRight';
  const menuWidth = menu.getBoundingClientRect().width;
  const pageExist = isPageExist(data);
  if (!pageExist) {

    // switch (data) {
    //   case 'about':
    //     aboutWidgetInit(config.widgets.about);
    //     mobileBurgerStyleToggle();
    //     break;
    //   case 'gallery':
    //     if (isMobile){
    //       galleryMobile(config.widgets.gallery);
    //       mobileBurgerStyleToggle();
    //     } else {
    //      galleryDesktop(config.widgets.gallery);
    //       mobileBurgerStyleToggle();
    //     }
    //     break;
    //   case 'map':
    //     poiWidgetInit(config.widgets.poi);
    //     mobileBurgerStyleToggle();
    //     break;
    //
    // }
    //
    // const pageExist = isPageExist(data);
    // pageExist && pageExist.classList.add('show-page');
    // if (!autoLoad){
    //   const preloaderContainer = createHtmlElement(document.body,'','div',['menu__iframe__preloader']);
    //   preloaderContainer.style[marginLang] = menuWidth + 'px';
    //   addIframePreloader(preloaderContainer);
    // }
    //
    // const container = createHtmlElement(document.body,'','iframe',['content__page']);
    // // if (autoLoad){
    // //   container.classList.add('hide-page');
    // // }
    //
    // container.style[paddingLang] = menuWidth + 'px';
    // container.dataset.menuItem = data;
    // const currentLang = getCurrentLang();
    // const url = crm[data + 'WebviewURL']+`&lang=${currentLang}`;
    // container.src = url;
    // container.onload = ()=> {
    //   const preloader = document.querySelector('.menu__iframe__preloader');
    //   if (preloader){
    //     preloader.remove();
    //   }
    // }
  } else {
    pageResize(pageExist);
    mapElementStyleToggle(pageExist);
    pageExist.classList.add('show-page');
    mobileBurgerStyleToggle();
  }
}

export function pageResize (page) {
  if (isDesktopMode()) {
    const menuHeight = document.querySelector('.aside__container').getBoundingClientRect().height;
    // page.style.paddingBottom = menuHeight + 'px';
    page.style.removeProperty('padding-top');

    return;
  }
  const data = page.dataset.menuItem;
  const direction = getCurrentLangDirection();
  const importantDirection = isDesktopMode();
  let paddingLang = direction === 'ltr' ? 'paddingLeft' : 'paddingRight';
  const marginLang = direction === 'ltr' ? 'marginLeft' : 'marginRight';
  let menuWidth = document.querySelector('.aside__container').dataset.initialWidth;

  page.firstElementChild && page.firstElementChild.style.removeProperty('padding-left');
  page.firstElementChild && page.firstElementChild.style.removeProperty('padding-right');
  page.style.removeProperty('margin-right');
  page.style.removeProperty('margin-left');
  page.style.removeProperty('padding-left');
  page.style.removeProperty('padding-right');

  if (!isMobile) {
    if (importantDirection) {
      paddingLang = 'paddingRight';
    }
    page.style.paddingTop = 0;
    page.style[paddingLang] = menuWidth + 'px';
  }

}

export function mobileBurgerStyleToggle () {
  const burger = document.querySelector('.burger__mobile__btn');
  const widgetPageIsOpened = document.querySelector('.widget__container.show-page');
  const contactUs = document.querySelector('.contact-us');
  const search = document.querySelector('.search__container-main');
  const poiCardInOrbit = document.querySelector('.poi__info-window.orbit__mode');

  const moduleOpen = widgetPageIsOpened || contactUs || search || poiCardInOrbit;

  if (moduleOpen && burger) {
    burger.classList.add('mobile-burger__white');
  } else if (burger && settingsData.activeViewMode === ViewMode.Cylinder) {
    burger.classList.add('mobile-burger__white');
  } else if (burger && settingsData.activeViewMode === ViewMode.Orbit) {
    burger.classList.remove('mobile-burger__white');
  } else if (!moduleOpen && burger && burger.classList.contains('mobile-burger__white')) {
    burger.classList.remove('mobile-burger__white');
  }
}

export function updatePagesStyle () {
  const pages = document.querySelectorAll('.content__page');
  pages.forEach(page => {
    pageResize(page);
  });
}

function getIconMoon (key) {
  const icons = {
    '3dModel': 'icon-home2',
    'about': 'icon-info',
    'applyNow': 'icon-external-link',
    'availability': 'icon-available2',
    'gallery': 'icon-gallery',
    'getApp': ['icon-playmarket', 'icon-appstore'],
    'map': 'icon-map-pin-outline',
    'favorites': 'icon-unselected',
    'contactUs': 'icon-call',
    'search': 'icon-search',
  };

  return icons[key];
}

function setMenuIcoMoon () {
  const menuItems = document.querySelectorAll('.aside__navigation-menu__href');
  menuItems.forEach(menu => {

    const dataItem = menu.getAttribute('data-menu-item');
    const trigger = 'hover';

    setLordIcon(dataItem,menu,{
      trigger: trigger,
      delay:'0'
    },'afterbegin');

  });
}

function animateMenu (menu, burger, param) {
  if (param) {
    menu.style.opacity = 1;
    return;
  }
  const langDirection = getCurrentLangDirection();
  const importantDirection = isDesktopMode();
  let side = langDirection === 'ltr' ? 'left' : 'right';

  if (importantDirection) {
    side = 'bottom';
  }

  if (isMobile) {
    menu.style.opacity = 1;

    gsap.fromTo(burger, {[side]: -200, opacity: 0}, {
      [side]: 15, opacity: 1, duration: 1, onComplete: () => {
        resetMenuAnimation(burger);
      },
    });


    return;
  }
  gsap.fromTo(menu, {[side]: -200, opacity: 0}, {
    [side]: 0, opacity: 1, duration: 1, onComplete: () => {
      resetMenuAnimation();
    },
  });
}

export function resetMenuAnimation (menu) {
  const menuElement = menu || document.querySelector('.aside__container');
  menuElement.style.removeProperty('left');
  menuElement.style.removeProperty('right');
  menuElement.style.removeProperty('bottom');
}

export function additionalMenuToggle () {
  if (!isMobile){
    return;
  }

  const additionalMenu = document.querySelector('.additional-menu__container');
  if (!additionalMenu){
    return;
  }

  if (settingsData.isLandscape && settingsData.activeViewMode === ViewMode.Orbit) {
    additionalMenu.style.display = 'block';
  } else if (!settingsData.isLandscape) {
    additionalMenu.style.display = 'block';
  } else {
    additionalMenu.style.display = 'none';
  }

}